import About from "src/components/About/About";

export default {
    aboutComponent: null,

    dispose() {
        if (this.aboutComponent) {
            this.aboutComponent.dispose();
        }
        this.aboutComponent = null;
    },

    show(currentYear: number) {
        if (!this.aboutComponent) {
            this.aboutComponent = new About({
                source: '<x-about></x-about>'
            });
            this.aboutComponent.attach(document.body);
        }
        this.aboutComponent.show(currentYear);
    }
};